import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_MONITORING_LOAD_BY_ID,
    ACTION_MONITORINGS_LOAD_BY_TRIALINSTITUTION_ID,
    ACTION_MONITORING_LOAD_FAILURE,
    ACTION_MONITORING_LOAD_SUCCESS,

    ACTION_MONITORING_SAVE,
    ACTION_MONITORING_SAVE_SUCCESS,
    ACTION_MONITORING_SAVE_FAILURE,

    ACTION_MONITORING_CREATE,
    ACTION_MONITORING_CREATE_SUCCESS,
    ACTION_MONITORING_CREATE_FAILURE,

    ACTION_MONITORING_VALIDATE,
    ACTION_MONITORING_VALIDATE_SUCCESS,
    ACTION_MONITORING_VALIDATE_FAILURE,

    ACTION_MONITORING_CLEAR,
    ACTION_MONITORING_FILTER,

    MonitoringAction,
} from '../actions/monitoring';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IMonitoringState {
    formData: Dtos.Monitoring | Dtos.Monitoring[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.Monitoring[];
    formLength: number;
}

const initialState: IMonitoringState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: IMonitoringState, _isLoading: boolean): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IMonitoringState,
    formData: Dtos.Monitoring | Dtos.Monitoring[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: IMonitoringState, responseStatus: Dtos.ResponseStatus): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: IMonitoringState, formFilter: IFormFilter): IMonitoringState {

    const items: Dtos.Monitoring[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" ||
            p.startDate.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IMonitoringState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: IMonitoringState, propertiesToClear?: string[]): IMonitoringState {

    if (!propertiesToClear) {
        const newState: IMonitoringState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IMonitoringState, _isSaving: boolean): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IMonitoringState,
    formData: Dtos.Monitoring | Dtos.Monitoring[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IMonitoringState, responseStatus: Dtos.ResponseStatus): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IMonitoringState, _isCreating: boolean): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IMonitoringState,
    formData: Dtos.Monitoring,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IMonitoringState, responseStatus: Dtos.ResponseStatus): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: IMonitoringState, _isValidating: boolean): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IMonitoringState,
    formData: Dtos.Monitoring,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IMonitoringState, responseStatus: Dtos.ResponseStatus): IMonitoringState {
    const newState: IMonitoringState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}


const MonitoringReducer: Reducer<IMonitoringState> = (state: IMonitoringState = initialState, action: MonitoringAction) => {
    switch (action.type) {
        case ACTION_MONITORING_LOAD_BY_ID:
        case ACTION_MONITORINGS_LOAD_BY_TRIALINSTITUTION_ID:
            return loading(state, true);
        case ACTION_MONITORING_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_MONITORING_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_MONITORING_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_MONITORING_SAVE:
            return saving(state, true);
        case ACTION_MONITORING_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_MONITORING_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_MONITORING_CREATE:
            return creating(state, true);
        case ACTION_MONITORING_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_MONITORING_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_MONITORING_VALIDATE:
            return validating(state, true);
        case ACTION_MONITORING_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_MONITORING_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_MONITORING_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default MonitoringReducer;